import { render, staticRenderFns } from "./ListDeliverablesPage.vue?vue&type=template&id=ec0d9aca"
import script from "./ListDeliverablesPage.vue?vue&type=script&lang=js"
export * from "./ListDeliverablesPage.vue?vue&type=script&lang=js"
import style0 from "./ListDeliverablesPage.vue?vue&type=style&index=0&id=ec0d9aca&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports